import { render, staticRenderFns } from "./barcode-scanner.vue?vue&type=template&id=95cc1de2&"
import script from "./barcode-scanner.vue?vue&type=script&lang=js&"
export * from "./barcode-scanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports